import type { AxiosResponse } from 'axios';
import { BaseService } from './baseService';
import axiosInstance from '../superadminAxiosInstance';

class UsersService extends BaseService<User, 'userID', 'users'> {
	constructor() {
		super('userID', 'user', 'users');
	}

	async getSelf(queryParams?: { [key: string]: string }): Promise<User> {
		const response: AxiosResponse<TavoittajaApiResponse<{ user: User }>> =
			await axiosInstance.get(`/superAdmin/users/self`, {
				params: {
					...queryParams,
				},
			});

		return response.data.data.user;
	}

	async deleteMultipleUsers(data: DeleteMultipleUsersRequest): Promise<void> {
		await axiosInstance.post(
			`/superadmin/${this.crudResponseArrayName}/batch`,
			data,
		);
	}

	async getAllSuperAdmins(queryParams?: {
		[key: string]: string | undefined;
	}): Promise<TavoittajaApiArrayResponse<'users', User[]>> {
		const response: AxiosResponse<
			TavoittajaApiArrayResponse<'users', User[]>
		> = await axiosInstance.get(
			`/superAdmin/${this.crudResponseArrayName}/superAdmins`,
			{
				params: {
					...queryParams,
				},
			},
		);

		return response.data;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new UsersService();
